import React, {PureComponent} from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header/Header";

import headerImg from "../../assets/images/backgrounds/skärm1.jpg";
import startup from "../../assets/images/services/admin.jpg";
import startup1 from "../../assets/images/services/uppföljning.jpg";
import uiux from "../../assets/images/services/kund.jpg";
import astronauts from "../../assets/images/services/moln.jpg";
import RouteButton from "../../components/RouteButton/RouteButton";

import "./Services.css";

class Services extends PureComponent {
  componentDidMount() {
    if(this.props.match.params && this.props.match.params.scroll) {
      const offset = window.innerWidth > 768 ? (window.innerHeight *0.95)  : (window.innerHeight * 0.6);
      window.scrollTo(0, offset);
    }
  }
  render() {
    return (
      <div className="services">
        <Helmet>
          <title>Corviva | Tjänster</title>
          <meta name="description" content="Digital plattform för enkäter, undersökningar och möten som riktar sig till företag och organisationer som arbetar inom hälsa och arbetsmiljö." />
          <meta name="keywords" content="webbportal hälsa företagshälsovård arbetsmiljö hälsoundersökning" />
        </Helmet>
        <Header
          big_header="tjänster"
          bgImage={headerImg}
          strength={200}
          page="services"
          offset={window.innerWidth <= 768 ? -80.5 : -70}
        />
        <div id="services" name="services" className="container-fluid">
          <div className="row section rightSection equal-height">
            <div className="col-12 col-xl-6 col-md-8 offset-md-2 offset-xl-1 serviceText">
              <div className="section-text text-left text-center text-lg-left">
                <h3>WEBBPORTAL - ADMIN</h3>
                <p>
                Många ser svåra och tidskrävande program som ett av de största 
                hindren i arbetet. Vi har därför haft användarvänlighet och enkelhet 
                som utgångspunkt för webbportalens admindel. Exempel är 
                smidig och säker inloggning med BankID, enkel hantering av kunder 
                och kartläggningar samt automatiserade mejlutskick.
                <br/>
                <br/>
                Ni kan använda modulbaserade enkäter med färdiga moduluppsättningar 
                för olika typer av kunder. Om ni vill skräddarsy en enkät ytterligare 
                kan ni enkelt bocka i/ur frågemoduler för att anpassa enkäten efter 
                era behov.
                </p>
                <ul className="dot-list">
                  <li>
                    <span>Användarvänligt</span>
                  </li>
                  <li>
                    <span>Automatiserade utskick</span>
                  </li>
                  <li>
                    <span>Modulanpassade enkäter</span>
                  </li>
                  <li>
                    <span>Smarta funktioner</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="subSection col-12 offset-xl-1 col-xl-3 ">
              <img className="imgRight img-fluid firstImg" alt="" src={startup} />
            </div>
          </div>
          <div className="row equal-height section leftSection ">
        
            <div className="col-12  col-xl-6 col-md-8 offset-md-2 offset-xl-1 serviceText text-center text-lg-left">
              <div className="section-text text-center text-lg-left text-lg-left ">
                <h3>WEBBPORTAL - KUND</h3>
                <p>
                  Kundportalen är skapad med responsiv webbdesign som gör att det 
                  går att köra i alla enheter – dator, surfplatta och mobil. Kunder 
                  kan logga in med BankID eller lösenord för att ta del av tjänsterna 
                  på portalen. Med BankID kan individen också ta del av känsliga 
                  resultat direkt på webben.
                  <br/>
                  <br/>
                  Corviva har satsat på att skapa en kundportal som är enkel att använda 
                  och som ger ett modernt intryck för användaren. Vi har tagit fram ett 
                  språkstöd som gör att vi enkelt kan översätta kundportalen till andra språk,  
                  t.ex. engelska.
                </p>
                <ul className="dot-list">
                  <li>
                    <span>Modern design</span>
                  </li>
                  <li>
                    <span>Alla enheter</span>
                  </li>
                  <li>
                    <span>Språkstöd</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="subSectionLeft col-12 offset-xl-1 col-xl-3">
              <img className="imgLeft img-fluid" alt="" src={uiux} />
            </div>
          </div>
          <div className="row equal-height section rightSection">
            <div className="col-12 col-md-8 offset-md-2 offset-xl-1 col-xl-6 serviceText">
              <div className="section-text text-center text-lg-left mx-auto">
                <h3>Uppföljning</h3>
                <p>
                Kunder lyfter ofta fram uppföljningen som den största fördelen med 
                Corviva. Individen kan se sina resultat direkt på portalen och resultaten 
                uppdateras omedelbart i samband med att en enkät, konsultation eller 
                undersökning genomförts.
                <br/>
                <br/>
                För grupprapportering räcker det med några knapptryck. Rapporterna 
                är färdiga med diagram, tabeller och texter. Texterna 
                anpassas efter resultat vilket gör att rapporterna upplevs personligt 
                skrivna. Ni kan istället fokusera på förslag om åtgärder, som ni 
                enkelt lägger till i rapporterna!
                </p>
                <ul className="dot-list">
                  <li>
                    <span>Omedelbar individåterkoppling</span>
                  </li>
                  <li>
                    <span>Automatiska grupprapporter</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="subSection col-12 col-xl-3 offset-xl-1">
              <img className="imgRight img-fluid" alt="" src={startup1} />
            </div>
          </div>
          <div className="row equal-height section leftSection">
            <div className="col-12 col-md-8 offset-md-2 col-xl-6 offset-xl-1 serviceText last-child">
              <div className="section-text text-center text-lg-left mx-auto">
                <h3>Molntjänst - SAAS</h3>
                <p>
                Corvivas digitala plattform levereras som en molntjänst enligt 
                ”Software As A Service” där allt ingår till en månadsavgift. 
                Allt som krävs är att ni och era kunder kan surfa in via en webbläsare. 
                Ni slipper klientinstallationer och egen drift, får snabbare 
                uppdateringar och enklare support samt slipper dyra licenskostnader.
                </p>
                <ul className="dot-list">
                  <li>
                    <span>Inga installationer</span>
                  </li>
                  <li>
                    <span>Smidig support</span>
                  </li>
                  <li>
                    <span>Månadsavgift</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="subSectionLeft offset-xl-1 col-xl-3 ">
              <img className="imgLeft img-fluid" alt="" src={astronauts} />
            </div>
          </div>
        </div>
        <div className="service-contact">
          <p>Har ni 30 minuter över för att se morgondagens lösningar?</p>
          <RouteButton
            linkTo="/contact/form"
            buttonText="Boka Demo"
            class_names="btn btn-corviva"
          />
        </div>
      </div>
    );
  }
  
};

export default Services;



// WEBPACK FOOTER //
// ./src/routes/Services/Services.jsx